import { render, staticRenderFns } from "./advantagesCompany.vue?vue&type=template&id=5c0e71ac&scoped=true&"
import script from "./advantagesCompany.vue?vue&type=script&lang=js&"
export * from "./advantagesCompany.vue?vue&type=script&lang=js&"
import style0 from "./advantagesCompany.vue?vue&type=style&index=0&id=5c0e71ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0e71ac",
  null
  
)

export default component.exports